module.exports = "<div class=\"loaderDiv\" *ngIf=\"showLoading\">\n  <div class=\"loader\"></div>\n</div>\n<router-outlet></router-outlet>\n"